import Box from '@mui/material/Box'

export const BottomBar = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 1,
        backgroundColor: theme => theme.palette.LKQGrey.background.highlight,
        color: theme => theme.palette.common.white
      }}
    />
  )
}
